import ApiBaseService from './ApiBaseService';

class UserService {

    static getUserList([data]) {
        return ApiBaseService.request('/api/web/user/list', 'POST', data);
    }
    static getDropdownUser([data = {}]) {
        return ApiBaseService.request('/api/web/user/dropdown', 'POST', data);
    }
    static createUser([data]) {
        return ApiBaseService.request('/api/web/user/create', 'POST', data);
    }
    static updateUserByUuid([data, userUuid]) {
        return ApiBaseService.request(`/api/web/user/update/${userUuid}`, 'PUT', data);
    }
    static getUserByUuid([userUuid]) {
        return ApiBaseService.request(`/api/web/user/details/${userUuid}`, 'GET');
    }
    static removeUserByUuid([userUuid]) {
        return ApiBaseService.request(`/api/web/user/remove/${userUuid}`, 'PUT', {});
    }
    static changeUserPasswordByUuid([data, userUuid]) {
        return ApiBaseService.request(`/api/web/user/change_password/${userUuid}`, 'PUT', data);
    }
    static changeUserStatusByUuid([userUuid]) {
        return ApiBaseService.request(`/api/web/user/status/${userUuid}`, 'PUT', {});
    }

}

export default UserService;